import { render, staticRenderFns } from "./TrainingVideos.vue?vue&type=template&id=3c13ae1a&scoped=true"
import script from "./TrainingVideos.vue?vue&type=script&lang=js"
export * from "./TrainingVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c13ae1a",
  null
  
)

export default component.exports